export const AccountConstants = {
    SubscriptionInfo: "SubscriptionInfo",
    AccountInfo: "AccountInfo",
    AccountUser: "AccountUser",
    UserRoles: "UserRoles",
    WTW: "willistowerswatson.com",
    Willis: "willis.com",
    Session:'SessionStatus'
}


// WEBPACK FOOTER //
// ./src/app/modules/account/account.const.ts